import { render } from "./ThongTinKhaiBaoVe.vue?vue&type=template&id=71865417"
import script from "./ThongTinKhaiBaoVe.vue?vue&type=script&lang=js"
export * from "./ThongTinKhaiBaoVe.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__